import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { QueryClientProvider } from '@tanstack/react-query';
import { queryClient } from './src/lib/react-query';
import App from './App';
import { ErrorBoundary } from './src/components/ui/ErrorBoundary';
import { registerSW } from 'virtual:pwa-register';
import './index.css';

// Registra explicitamente o Service Worker do PWA
if ('serviceWorker' in navigator) {
  registerSW({
    immediate: true,
    onNeedRefresh() {
      console.log('Nova versão disponível. Por favor, atualize a página.');
    },
    onOfflineReady() {
      console.log('PWA pronto para funcionar offline.');
    }
  });
}

// Captura o prompt de instalação do PWA globalmente
window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  (window as any).deferredPrompt = e;
  // Despacha um evento personalizado para que componentes React reativos saibam que o PWA pode ser instalado
  window.dispatchEvent(new CustomEvent('pwa-installable', { detail: e }));
});

window.addEventListener('appinstalled', () => {
  (window as any).deferredPrompt = null;
  localStorage.setItem('pwa_installed', 'true');
  window.dispatchEvent(new CustomEvent('pwa-installed'));
});

// Se o app já estiver rodando em modo standalone, salva no localStorage para ocultar banners no navegador
if (window.matchMedia('(display-mode: standalone)').matches || (navigator as any).standalone) {
  localStorage.setItem('pwa_installed', 'true');
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error("Could not find root element to mount to");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>
);